import React from 'react';
import { Button } from '@blueprintjs/core';
import { Select } from '@blueprintjs-formik/select';
import styled from 'styled-components';
import clsx from 'classnames';
import intl from 'react-intl-universal';

interface InputProps {
  activeItem?: any;
  text?: string;
  label?: string;
  value?: any;
  [key: string]: any;
}

export function FSelect({ selectedItemText = null, items = [] as any[], popoverProps: userPopoverProps, ...props }: any) {
  const input = ({ activeItem, text, label, value, ...inputProps }: InputProps) => {
    let displayText = selectedItemText || text;

    if (!displayText && activeItem && props.textAccessor) {
      displayText = typeof props.textAccessor === 'function'
        ? props.textAccessor(activeItem)
        : activeItem[props.textAccessor];
    }

    displayText = displayText || props.placeholder || intl.get('select_an_item');

    return (
      <SelectButton
        {...inputProps}
        text={displayText}
        disabled={props.disabled || false}
        {...props.buttonProps}
        className={clsx({ 'is-selected': !!(selectedItemText || text || activeItem) }, props.className)}
      />
    );
  };

  const safeItems = Array.isArray(items) ? items : [];
  const mergedPopoverProps = { usePortal: false, ...userPopoverProps };

  return <Select input={input} fill={true} items={safeItems} disabled={props.disabled} popoverProps={mergedPopoverProps} {...props} />;
}

export const SelectButton = styled(Button)`
  --x-color-select-background: #fff;
  --x-color-select-border: #ced4da;
  --x-color-select-caret: #8d8d8d;
  --x-color-select-text: #1c2127;

  .bp4-dark & {
    --x-color-select-background: rgba(17, 20, 24, 0.3);
    --x-color-select-border: rgba(255, 255, 255, 0.15);
    --x-color-select-caret: rgba(255, 255, 255, 0.25);
    --x-color-select-text: #f6f7f9;
  }
  outline: none;
  box-shadow: 0 0 0 transparent;
  border: 1px solid var(--x-color-select-border);
  position: relative;
  padding-inline-end: 30px;

  &.bp4-small {
    padding-inline-end: 24px;
  }
  &.is-selected:not([class*='bp4-intent-']):not(.bp4-minimal) {
    color: var(--x-color-select-text);

    .bp4-button-text {
      color: var(--x-color-select-text);
    }
  }
  &:not(.is-selected):not([class*='bp4-intent-']):not(.bp4-minimal) {
    color: #8f99a8;
  }
  &:after {
    content: '';
    display: inline-block;
    width: 0;
    height: 0;
    border-left: 4px solid transparent;
    border-right: 4px solid transparent;
    border-top: 5px solid var(--x-color-select-caret);

    position: absolute;
    inset-inline-end: 0;
    top: 50%;
    margin-top: -2px;
    margin-inline-end: 12px;
    border-radius: 1px;
  }
  &:not([class*='bp4-intent-']):not(.bp4-disabled) {
    &,
    &:hover {
      background: var(--x-color-select-background);
    }
  }
  .bp4-intent-danger & {
    border-color: #db3737;
  }
`;
